<template>
	<Modal headline="Reservation udløbet" :visible="visible" @close="hide()">
		<p>Din reservation af følgende produkter er udløbet, og de er blevet fjernet fra din indkøbskurv.</p>
		<ul class="productlist">
			<li v-for="product in deletedProducts" :key="product">
				{{ product }}
			</li>
		</ul>
	</Modal>
</template>

<script>
export default {
	computed: {
		visible: function() {
			return this.$store.getters.removedReservations.visible;
		},
		deletedProducts: function() {
			return this.$store.getters.removedReservations.deletedProducts;
		}
	},
	methods: {
		hide: function() {
			return this.$store.dispatch("hideRemovedReservations");
		}
	}
}
</script>
